import { BadgeTone } from './components/Badge';
import { FindingSeverity, FindingStatus } from '../types/finding';

/**
 * Single source of truth mapping finding severity / status to design-system
 * Badge tones + human labels. Replaces the ad-hoc colour maps that were
 * duplicated across SeverityBadge / FindingSeverityBadge / FindingStatusBadge /
 * SeverityPills / SlaStatusBadge, etc.
 */
export const SEVERITY_TONE: Record<FindingSeverity, BadgeTone> = {
  critical: 'critical',
  high: 'high',
  medium: 'medium',
  low: 'low',
};

export const SEVERITY_LABEL: Record<FindingSeverity, string> = {
  critical: 'Critical',
  high: 'High',
  medium: 'Medium',
  low: 'Low',
};

export const FINDING_STATUS_TONE: Record<FindingStatus, BadgeTone> = {
  open: 'open',
  needs_manual_review: 'review',
  resolved: 'resolved',
  ignored: 'muted',
  false_positive: 'muted',
};

export const FINDING_STATUS_LABEL: Record<FindingStatus, string> = {
  open: 'Open',
  needs_manual_review: 'Needs Review',
  resolved: 'Resolved',
  ignored: 'Ignored',
  false_positive: 'False Positive',
};
